"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var EvngDomManipulator = exports.default = /*#__PURE__*/function () {
  function EvngDomManipulator() {
    (0, _classCallCheck2.default)(this, EvngDomManipulator);
  }
  (0, _createClass2.default)(EvngDomManipulator, null, [{
    key: "removeAllElem",
    value: function removeAllElem(list) {
      if (list && list.length) {
        list.forEach(function (elem) {
          elem.remove();
        });
      }
    }
  }, {
    key: "initDomManipulations",
    value: function initDomManipulations() {
      EvngDomManipulator.removeFooterContent();
      EvngDomManipulator.makeContactButtonStatic();
      document.addEventListener('DOMContentLoaded', function () {
        EvngDomManipulator.removeFooterContent();
        EvngDomManipulator.makeContactButtonStatic();
      });
    }
  }, {
    key: "removeFooterContent",
    value: function removeFooterContent() {
      EvngDomManipulator.removeAllElem(document.querySelectorAll('.footer-cta'));
      EvngDomManipulator.removeAllElem(document.querySelectorAll('.footer-navigation-wrapper'));
    }
  }, {
    key: "makeContactButtonStatic",
    value: function makeContactButtonStatic() {
      var _document$querySelect;
      (_document$querySelect = document.querySelector('.contact-link')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.addEventListener('click', function () {
        location.href = EvngDomManipulator.redirectorPath;
      });
    }
  }]);
  return EvngDomManipulator;
}();
(0, _defineProperty2.default)(EvngDomManipulator, "redirectorPath", '/de/cic_service/redirector.html#destination=contact');